import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { GET, PUT, POST, httpOk } from 'helpers/api'

/**
 * SMS INTEGRATSIYASI — Eskiz.uz / Play Mobile.
 *
 * ⚠️ SaaS: har korxona O'Z provayderini, o'z login/parolini va (xohlasa)
 *    o'z alfa-nomini ulaydi. Ikkalasi ham bo'lmasligi mumkin — u holda modul
 *    shunchaki o'chiq turadi, boshqa hech narsaga ta'sir qilmaydi.
 *
 * ⚠️ SINOV REJIMI sukut bo'yicha YOQIQ. Sozlash paytida tasodifan 1000+
 *    mijozga haqiqiy SMS ketib, pul yonib ketmasin. Egasi tayyor bo'lganda
 *    o'zi o'chiradi.
 */
function Index() {
	const { t } = useTranslation()

	const [cfg, setCfg] = useState({
		provider: 'eskiz', api_login: '', api_password: '', token: '', originator: '',
		test_mode: true, daily_limit: 2000,
	})
	const [hasPassword, setHasPassword] = useState(false)
	const [hasToken, setHasToken] = useState(false)
	const [tokenExp, setTokenExp] = useState(null)
	const [balance, setBalance] = useState(null)
	const [saving, setSaving] = useState(false)

	const [testPhone, setTestPhone] = useState('')
	const [testing, setTesting] = useState(false)
	const [testResult, setTestResult] = useState(null)   // { ok, message }

	const [subs, setSubs] = useState(null)
	const [syncing, setSyncing] = useState(false)

	useEffect(() => { load() }, [])

	async function load() {
		const res = await GET('/broadcast/settings', {}, { loader: false })
		if (!httpOk(res)) return
		const d = res.data
		setCfg(p => ({
			...p,
			provider: d.provider || 'eskiz',
			api_login: d.api_login || '',
			api_password: '',
			token: '',
			originator: d.originator || '',
			test_mode: d.test_mode !== false,
			daily_limit: d.daily_limit || 2000,
		}))
		setHasPassword(!!d.has_password)
		setHasToken(!!d.has_token)
		setTokenExp(d.token_expires_at || null)
		setBalance(d.balance)
	}

	async function save() {
		setSaving(true)
		const res = await PUT('/broadcast/settings', cfg, { loader: true })
		setSaving(false)
		if (httpOk(res)) {
			toast.success(t('saved'))
			setCfg(p => ({ ...p, api_password: '', token: '' }))
			load()
		}
	}

	async function test() {
		setTesting(true)
		setTestResult(null)
		const res = await POST('/broadcast/settings/test', { phone: testPhone }, { loader: false })
		setTesting(false)
		if (httpOk(res)) {
			setTestResult({ ok: true, message: res.data?.message || 'Ulanish muvaffaqiyatli' })
			if (res.data?.balance != null) setBalance(res.data.balance)
		} else {
			setTestResult({ ok: false, message: res?.data?.message || 'Ulanib bo\'lmadi' })
		}
	}

	async function syncSubscribers() {
		setSyncing(true)
		const res = await POST('/broadcast/sync-subscribers', {}, { loader: false })
		setSyncing(false)
		if (httpOk(res)) setSubs(res.data?.subscribers ?? 0)
	}

	const isEskiz = cfg.provider === 'eskiz'

	return (
		<div className="an-page">
			<div className="page-header d-flex justify-content-between align-items-center mb-3">
				<h4 className="mb-0">SMS integratsiyasi</h4>
				<button className="btn btn-primary" onClick={save} disabled={saving}>
					<i className="uil-check me-1" />{t('save')}
				</button>
			</div>

			<div className="row g-3">
				<div className="col-md-7">
					<div className="card">
						<div className="card-body">

							<div className="form-group">
								<label>Provayder</label>
								<select className="form-select" value={cfg.provider}
									onChange={e => setCfg({ ...cfg, provider: e.target.value })}>
									<option value="eskiz">Eskiz.uz</option>
									<option value="playmobile">Play Mobile</option>
								</select>
								<div className="text-muted fz-14 mt-1">
									{isEskiz
										? 'Kirish ma\'lumotlari my.eskiz.uz → SMS sozlamalari sahifasidan olinadi (sayt paroli EMAS).'
										: 'Play Mobile shartnomasidagi login va parol.'}
								</div>
							</div>

							<div className="row">
								<div className="col-md-6 form-group">
									<label>Login {isEskiz && <span className="text-muted fz-14">(email)</span>}</label>
									<input type="text" className="form-control" value={cfg.api_login}
										onChange={e => setCfg({ ...cfg, api_login: e.target.value })} />
								</div>
								<div className="col-md-6 form-group">
									<label>Parol</label>
									<input type="password" className="form-control"
										placeholder={hasPassword ? "O'zgartirmaslik uchun bo'sh qoldiring" : ''}
										value={cfg.api_password}
										onChange={e => setCfg({ ...cfg, api_password: e.target.value })} />
								</div>
							</div>

							{/* TOKEN — IXTIYORIY.
							    Eskizda odatda kerak emas: dastur email/parol bilan tokenni
							    O'ZI oladi va 30 kunda bir yangilaydi. Bu maydon tayyor
							    tokeni borlar yoki parolni saqlashni istamaydiganlar uchun.
							    Play Mobile'da token umuman yo'q — u yerda faqat login/parol. */}
							{isEskiz &&
								<div className="form-group">
									<label>
										Token <span className="text-muted fz-14">(ixtiyoriy)</span>
										{hasToken && <span className="badge bg-success ms-2">saqlangan</span>}
									</label>
									<input type="password" className="form-control"
										placeholder={hasToken ? 'Saqlangan — o\'zgartirmaslik uchun bo\'sh qoldiring' : 'Odatda kerak emas'}
										value={cfg.token}
										onChange={e => setCfg({ ...cfg, token: e.target.value })} />
									<div className="text-muted fz-14 mt-1">
										Bo'sh qoldiring — dastur login/parol bilan tokenni o'zi oladi va
										muddati tugaganda o'zi yangilaydi.
										{tokenExp && <> Joriy token muddati: <b>{String(tokenExp).slice(0, 10)}</b></>}
									</div>
								</div>
							}

							<div className="form-group">
								<label>
									Alfa-nom <span className="text-muted fz-14">(ixtiyoriy)</span>
								</label>
								<input type="text" className="form-control" placeholder={isEskiz ? '4546' : '3700'}
									value={cfg.originator}
									onChange={e => setCfg({ ...cfg, originator: e.target.value })} />
								{/* ⚠️ Egasiga aniq aytamiz: alfa-nom SHART EMAS. Bo'sh qolsa
								    xabar provayderning qisqa raqamidan ketadi va baribir yetadi. */}
								<div className="text-muted fz-14 mt-1">
									Bo'sh qoldirilsa xabar <b>{isEskiz ? '4546' : '3700'}</b> raqamidan ketadi.
									O'z nomingiz bilan yuborish uchun provayderdan alfa-nom olinadi
									(taxminan 1 oy, bir martalik to'lov).
								</div>
							</div>

							<div className="row">
								<div className="col-md-6 form-group">
									<label>Kunlik chegara (SMS)</label>
									<input type="number" className="form-control" min="1"
										value={cfg.daily_limit}
										onChange={e => setCfg({ ...cfg, daily_limit: e.target.value })} />
									<div className="text-muted fz-14 mt-1">
										Kunlik shu sondan ortiq SMS ketmaydi — himoya.
									</div>
								</div>
								<div className="col-md-6 form-group">
									<label>Rejim</label>
									<div className={'p-2 rounded border ' + (cfg.test_mode ? 'border-warning' : 'border-danger')}>
										<div className="form-check form-switch">
											<input className="form-check-input" type="checkbox" id="tm"
												checked={!!cfg.test_mode}
												onChange={e => setCfg({ ...cfg, test_mode: e.target.checked })} />
											<label className="form-check-label" htmlFor="tm">
												{cfg.test_mode
													? <b className="text-warning">Sinov rejimi — SMS yuborilmaydi</b>
													: <b className="text-danger">HAQIQIY yuborish — pul ketadi</b>}
											</label>
										</div>
									</div>
								</div>
							</div>

						</div>
					</div>
				</div>

				<div className="col-md-5">
					{/* ── Tekshirish ── */}
					<div className="card">
						<div className="card-body">
							<h6 className="card-title fw-bold mb-3">Ulanishni tekshirish</h6>

							<div className="form-group">
								<label>Sinov raqami <span className="text-muted fz-14">(ixtiyoriy)</span></label>
								<input type="text" className="form-control" placeholder="998901234567"
									value={testPhone} onChange={e => setTestPhone(e.target.value)} />
								<div className="text-muted fz-14 mt-1">
									Raqam yozilsa — shu raqamga bitta sinov SMS ketadi (sinov rejimida ham).
								</div>
							</div>

							<button className="btn btn-outline-primary w-100" onClick={test} disabled={testing}>
								{testing ? t('loading') : 'Tekshirish'}
							</button>

							{testResult &&
								<div className={'alert mt-3 mb-0 py-2 ' + (testResult.ok ? 'alert-success' : 'alert-danger')}>
									{testResult.message}
								</div>
							}

							{balance != null &&
								<div className="mt-3">
									<span className="text-muted">Balans: </span>
									<b>{balance}</b>
									<div className="text-muted fz-14">
										Provayder o'lchov birligini bildirmaydi (so'm yoki SMS krediti).
									</div>
								</div>
							}
						</div>
					</div>

					{/* ── Telegram obunachilari ── */}
					<div className="card mt-3">
						<div className="card-body">
							<h6 className="card-title fw-bold mb-2">Telegram obunachilari</h6>
							{/* ⚠️ Telegram qoidasi: mijozga xabar yuborish uchun u AVVAL botga
							    yozgan bo'lishi shart. Shuning uchun chekdagi QR muhim —
							    obunachi bazasi o'sha orqali to'planadi. */}
							<div className="text-muted fz-14 mb-2">
								Telegramga xabar yuborish uchun mijoz avval botga yozgan bo'lishi kerak
								(Telegram qoidasi). Chekdagi QR kod aynan shuning uchun.
								Telegram <b>tekin</b> — SMS esa pullik.
							</div>
							<button className="btn btn-outline-secondary btn-sm" onClick={syncSubscribers} disabled={syncing}>
								{syncing ? t('loading') : 'Obunachilarni yangilash'}
							</button>
							{subs != null &&
								<div className="mt-2">
									Obunachilar: <b>{subs}</b>
								</div>
							}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}

export default Index
